import { useState } from "react";

export default function StepVisualEnhancements({ onNext, onBack, formData }) {
  const [visuals, setVisuals] = useState(formData.visualEnhancements || false);

  return (
    <div>
      <h2 className="text-xl font-semibold mb-2">Add Visual Enhancements?</h2>
      <label className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          checked={visuals}
          onChange={e => setVisuals(e.target.checked)}
        />
        <span>Charts, Tables, Diagrams</span>
      </label>
      <div className="flex gap-2 mt-4">
        <button className="btn btn-secondary" onClick={onBack}>Back</button>
        <button className="btn btn-primary" onClick={() => onNext({ visualEnhancements: visuals })}>
          Next
        </button>
      </div>
    </div>
  );
}